/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var COCInternalSidebarNavView = require('../../internal-dashboard/views/COCInternalSidebarNavView');

var tmplCOCEntityNewView = require('../templates/COCEntityNewView.hbs');
var SubmitEntity = require('../services/SubmitEntity');
var COCEntityFormView = require('./COCEntityFormView');
require('../styles/COCEntityNewView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEntityNewView,

  className: 'coc-entity-new-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    sideBar: '.side-bar-container',
    entityFormContainer: '.entity-form-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    sideBar: '@ui.sideBar',
    entityFormContainer: '@ui.entityFormContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            text: 'Create New Entity'
          }
        ]
      })
    );
    this.entityForm = new COCEntityFormView({
      model: new Backbone.Model({
        entityTypes: this.model.get('entityTypes'),
        organizationTypes: this.model.get('organizationTypes')
      })
    });
    this.showChildView('entityFormContainer', this.entityForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var lookupHashes = {
      entityTypes: this.model.get('entityTypes'),
      organizationTypes: this.model.get('organizationTypes')
    };
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        SubmitEntity(self.getFormData(), lookupHashes)
          .done(function(entity) {
            Radio.channel('navigate').trigger('show:int:coc:entity-view', entity.newEntityId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.entityFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.entityForm.getFormData();
  }
});
